<template>
  <div :style="{ padding: paddingValue }"></div>
</template>

<script>
export default {
  name: 'LayoutBlank',
  props: {
    value: {
      type: Number,
      default: 24,
    },
  },
  computed: {
    paddingValue() {
      return `${this.value}px`;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/spa/components/LayoutBlank.vue